import loadable from '@loadable/component'

export default [
  {
    path: '/anchorcenter/center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter" */ '~/pages/AnchorCenter'
        )
    ),
  },
  {
    path: '/anchorcenter/unionlive',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-UnionLive" */ '~/pages/AnchorCenter/UnionLive'
        )
    ),
  },
  {
    path: '/anchorcenter/anchormanage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-AnchorManage" */ '~/pages/AnchorCenter/AnchorManage'
        )
    ),
  },
  {
    path: '/anchorcenter/paymentway',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-PaymentWay" */ '~/pages/AnchorCenter/PaymentWay'
        )
    ),
  },
  {
    path: '/anchorcenter/inviteanchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-InviteAnchor" */ '~/pages/AnchorCenter/InviteAnchor'
        )
    ),
  },
  {
    path: '/anchorcenter/giftdetails',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-GiftDetails" */ '~/pages/AnchorCenter/GiftDetails'
        )
    ),
  },
  {
    path: '/anchorcenter/liveDetails',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-liveDetails" */ '~/pages/AnchorCenter/components/LiveData/LiveDetails'
        )
    ),
  },
  {
    path: '/anchorcenter/invitation/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-invitation" */ '~/pages/AnchorCenter/invitation'
        )
    ),
  },
  // 公会长代收记录
  {
    path: '/anchorcenter/PayLeaderRecords',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-PayLeaderRecords" */ '~/pages/AnchorCenter/PayLeaderRecords'
        )
    ),
  },
  // 退款记录列表
  {
    path: '/anchorcenter/RefundList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-RefundList" */ '~/pages/AnchorCenter/RefundList'
        )
    ),
  },
  // 退款记录详情
  {
    path: '/anchorcenter/RefundDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-RefundDetail" */ '~/pages/AnchorCenter/RefundDetail'
        )
    ),
  },
  // 全部 退款记录列表
  {
    path: '/anchorcenter/AllRefundList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-AllRefundList" */ '~/pages/AnchorCenter/AllRefundList'
        )
    ),
  },
  // 全部 退款记录详情
  {
    path: '/anchorcenter/AllRefundDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-AllRefundDetail" */ '~/pages/AnchorCenter/AllRefundDetail'
        )
    ),
  },
  // 仅工会长可见的公会实时数据
  {
    path: '/anchorcenter/RealTimeData',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-RealTimeData" */ '~/pages/AnchorCenter/RealTimeData'
        )
    ),
  },
  // 主播等级
  {
    path: '/anchorcenter/AnchorLevel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-AnchorLevel" */ '~/pages/AnchorCenter/AnchorLevel'
        )
    ),
  },
  // 工会发薪指导
  {
    path: '/anchorcenter/LeaderSalaryGuide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-LeaderSalaryGuide" */ '~/pages/AnchorCenter/LeaderSalaryGuide'
        )
    ),
  },
  // 工会发薪指导详情
  {
    path: '/anchorcenter/LeaderSalaryGuide/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-LeaderSalaryGuide-detail" */ '~/pages/AnchorCenter/LeaderSalaryGuide/detail'
        )
    ),
  },
]
